<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @submit.prevent="doLogin()">
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  
                  <b-form-group style="margin-bottom: 0px; ">
                    <b-input-group class="mb-3">
                      <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                      <b-form-input v-model="email" type="email" class="form-control" placeholder="E-mail" autocomplete="email" />
                    </b-input-group>
                  </b-form-group>

                  <b-form-group :description="error">
                    <b-input-group class="mb-4">
                      <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                      <b-form-input v-model="password" type="password" class="form-control" placeholder="Password" autocomplete="current-password" />
                    </b-input-group>
                  </b-form-group>

                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" class="px-4" type="submit">Login</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <!-- <b-button variant="link" class="px-0">Forgot password?</b-button> -->
                    </b-col>
                  </b-row>

                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { globalStore } from '@/main'

export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: '',
      error: ''
    }
  },
  mounted () {
    if (this.$store.getters.isUserLoggedIn) {
      this.$router.push('/applications')
    }
  },
  methods: {
    doLogin: function () {
      let cmp = this
      cmp.$store.dispatch('loginUser', {email: cmp.email, password: cmp.password})
        .then(response => {
          // this.$store.dispatch('fetchImplementationsList').then(() => {
            this.$router.go('/applications')
          // })
        }, error => {
          cmp.error = 'Incorrect authorization data';
        })
    }
  }
}
</script>

<style>
  .text-muted {
    color: #e41429;
  }
</style>
